import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { NotesPermissionsDto } from '@nx-frontend/shared/types';
import { ServicePayload } from '@nx-frontend/shared/types/api';

interface GetNotesPermissions extends ServicePayload {
  workspaceId: string;
}
export const getUsersPermissionsForWorkspace = async ({
  host,
  userId,
  workspaceId,
}: GetNotesPermissions): Promise<NotesPermissionsDto> => {
  if (!workspaceId) {
    return { notes: [], count: 0 };
  }
  const response = await axiosClient.get(`${assertServiceHost(host)}/v1/workspaces/${workspaceId}/permissions`, {
    userId,
  });
  return {
    notes: response.data,
    count: response.headers['x-total-count'] ?? 0,
  };
};
